
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15.518","height":"18.488","viewBox":"0 0 15.518 18.488"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 272","transform":"translate(-24.241 -19.498)"}},[_c('g',{attrs:{"data-name":"Union 5","fill":"none","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M37.036 37.986a2.671 2.671 0 002.723-2.617l-.545-11.783a1.336 1.336 0 00-1.36-1.3h-2.219a3.765 3.765 0 00-7.27 0h-2.082a1.336 1.336 0 00-1.361 1.3l-.681 11.779a2.672 2.672 0 002.718 2.621z"}}),_c('path',{attrs:{"d":"M37.036 35.986c.387 0 .704-.261.722-.588l-.514-11.117h-1.609a2 2 0 01-1.936-1.496c-.197-.758-.895-1.287-1.699-1.287-.803 0-1.502.53-1.7 1.287a2 2 0 01-1.935 1.496h-1.48l-.643 11.124c.023.324.338.581.722.581h10.072m0 2H26.964c-1.503 0-2.723-1.172-2.723-2.617l.681-11.78c0-.722.61-1.308 1.361-1.308h2.082A3.747 3.747 0 0132 19.498a3.747 3.747 0 013.635 2.783h2.219c.751 0 1.36.586 1.36 1.309l.545 11.779c0 1.445-1.219 2.617-2.723 2.617z","fill":"#fff"}})]),_c('path',{attrs:{"data-name":"Path 253","d":"M29.34 22.728v4.183","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-width":"2"}}),_c('rect',{attrs:{"data-name":"Rectangle 47","width":"4","height":"5","rx":"1","transform":"translate(27.232 26.242)","fill":"#fff"}})])])
          )
        }
      }
    